export default __webpack_public_path__ + "static/media/news-banner.7dce9bcd.png";